import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import type { Schema as PMSchema } from '@atlaskit/editor-prosemirror/model';

import { convoAIStatefulApiURL } from '../../prebuilt/utils';
import { startStreamingResponse } from '../start-streaming-response';
import { streamResponseParser } from './utils/stream-response-parser';

/**
 * Opens chat session with Rovo Agent.
 *
 * Intended for use in EditorPluginAI config items and Rovo agents.
 * @see {@link [EditorPluginAI](../../editor-plugin-ai.tsx)}
 * @see https://hello.atlassian.net/wiki/spaces/EDAI/pages/3753154519/Rovo+Agents+in+Editor
 */

/**
 * A generator function that will fetch the response from the Convo AI API.
 *
 * Status: WIP (wrong assistance-service agent and payload)
 */
export var rovoChatWithAgent = function rovoChatWithAgent(input) {
  var agent = input.agent;
  return function promptRequest(requestOptions) {
    var _requestOptions$getCh, _requestOptions$getCh2;
    var promptADF = input.customPromptADF || {
      version: 1,
      type: 'doc',
      content: [{
        type: 'paragraph',
        content: [{
          type: 'text',
          text: input.customPrompt
        }]
      }]
    };

    // Just the main URL, remove the extra stuff like hashes/query params
    var browserUrl = (_requestOptions$getCh = (_requestOptions$getCh2 = requestOptions.getChannelVariables) === null || _requestOptions$getCh2 === void 0 || (_requestOptions$getCh2 = _requestOptions$getCh2.call(requestOptions, 'rovo-agent')) === null || _requestOptions$getCh2 === void 0 ? void 0 : _requestOptions$getCh2.contentURL) !== null && _requestOptions$getCh !== void 0 ? _requestOptions$getCh : window.location.origin + window.location.pathname;
    var streamingResponseGenerator = startStreamingResponse(_objectSpread({
      endpoint: convoAIStatefulApiURL,
      experienceId: 'ai-mate',
      channelId: requestOptions.channelId,
      // For payload spec, see https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3783312372/Actions+Contract+for+Confluence+Content+Suggestion
      payload: JSON.stringify({
        content: promptADF,
        // Is this meant to be `agent_input_context` in the future?
        context: {
          browser_url: browserUrl,
          editor: {
            document: {
              type: 'text/markdown',
              content: input.fullDocument
            },
            selection: {
              type: 'text/markdown',
              content: input.currentSelection
            }
          }
        },
        recipient_agent_named_id: agent.namedId,
        mimeType: 'text/adf',
        store_message: true
        // "citations_enabled": true
      })
    }, requestOptions));
    return streamResponseParser({
      streamingResponseGenerator: streamingResponseGenerator,
      isConvoAI: true
    });
  };
};